import { makeAutoObservable } from "mobx";
import { EmptyLoginUserObservableRequestImpl } from "../DTO/User";
import { AppStoreApi } from "./AppStore";

export class UserLoginStore {
  private user: EmptyLoginUserObservableRequestImpl;
  private root: AppStoreApi;

  constructor(root: AppStoreApi) {
    this.user = new EmptyLoginUserObservableRequestImpl();
    this.root = root;
    makeAutoObservable(this);
  }

  public onChangeUserMail = (event: React.FormEvent<HTMLInputElement>) => {
    this.user.onChangeMail(event.currentTarget.value);
  };

  public onChangeUserPassword = (event: React.FormEvent<HTMLInputElement>) => {
    this.user.onChangePassword(event.currentTarget.value);
  };

  public loginUser = (): Promise<boolean> => {
    return this.root.authStore.loginUserAsync(this.user);
  };
}
